<template>
  <div class="mt-2">
    <b-button variant="primary" @click="triggerAddParameter">Add Parameter</b-button><br>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>SI. No.</th>
          <th>Name</th>
          <th>Short Code</th>
          <th>Max Score</th>
          <th>COs</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(parameter, paramIndex) in method.parameters" :key="paramIndex">
          <td>
            <b-form-input v-if="!parameter.id || parameter.isEditing" v-model.number="parameter.serial_number"
              type="number" min="1" placeholder="No." size="sm" style="width: 70px;"
              :ref="`paramInput-${methodIndex}-${paramIndex}`" />
            <span v-else>{{ parameter.serial_number }}</span>
          </td>
          <td>
            <b-form-input v-if="!parameter.id || parameter.isEditing" v-model="parameter.name" placeholder="Enter name"
              size="sm" style="min-width: 300px;" />

            <span v-else>{{ parameter.name }}</span>

            <small
              v-if="validation.parameters.$each[paramIndex].name.$dirty && validation.parameters.$each[paramIndex].name.$invalid"
              class="text-danger">
              Name is required.
            </small>
          </td>
          <td>
            <b-form-input v-if="!parameter.id || parameter.isEditing" v-model="parameter.short_code"
              placeholder="Enter short code" size="sm"
              :class="{ 'is-invalid': validation.parameters.$each[paramIndex].short_code.$dirty && validation.parameters.$each[paramIndex].short_code.$invalid }" />

            <span v-else>{{ parameter.short_code }}</span>
            <small
              v-if="validation.parameters.$each[paramIndex].short_code.$dirty && validation.parameters.$each[paramIndex].short_code.$invalid"
              class="text-danger">
              Short code is required.
            </small>
          </td>
          <td>
            <b-form-input v-if="!parameter.id || parameter.isEditing" v-model="parameter.maximum_score" type="number"
              step="0.01" min="0" placeholder="Max score" size="sm" />

            <span v-else>{{ parameter.maximum_score }}</span>
            <small v-if="validation.parameters.$each[paramIndex].maximum_score.$dirty &&
              validation.parameters.$each[paramIndex].maximum_score.$invalid" class="text-danger">
              <span v-if="!validation.parameters.$each[paramIndex].maximum_score.required">Score is required.</span>
              <span v-else-if="!validation.parameters.$each[paramIndex].maximum_score.numeric">Score must be a
                number.</span>
            </small>
          </td>
          <td>
            <!-- NO COURSE OUTCOMES CONFIGURED -->
            <span
              v-if="courseOutcomeOptions.length === 0"
              class="text-danger font-weight-bold"
            >
              CO not updated in course
            </span>

            <!-- EDIT MODE / NEW -->
            <b-form-checkbox-group
              v-else-if="!parameter.id || parameter.isEditing"
              v-model="parameter.cos"
            >
              <b-form-checkbox
                v-for="(co, idx) in courseOutcomeOptions"
                :key="idx"
                :value="co.value"
              >
                {{ co.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>

            <!-- VIEW MODE -->
            <span v-else>
              {{ parameter.co_codes.join(', ') }}
            </span>
          </td>

          <td>
            <div class="d-flex align-items-center gap-2">
              <!-- Edit icon -->
              <i v-if="!parameter.isEditing && parameter.id" class="far fa-edit text-info"
                style="font-size: 15px; cursor: pointer;" @click="startEditing(paramIndex)"></i>

              <!-- Save / Update -->
              <b-button v-if="!parameter.id || parameter.isEditing" variant="success" size="sm"
                @click="parameter.isEditing = true; $emit('saveParameter', methodIndex, paramIndex)">
                {{ parameter.id ? 'Update' : 'Save' }}
              </b-button>

              <!-- Cancel -->
              <b-button v-if="!parameter.id || parameter.isEditing" variant="danger" size="sm"
                @click="$emit('cancelParameter', methodIndex, paramIndex, parameter.id)">
                Cancel
              </b-button>

              <!-- Delete icon -->
              <i v-if="!parameter.isEditing && parameter.id" class="fas fa-trash text-danger"
                style="font-size: 15px; cursor: pointer;"
                @click="$emit('deleteParameter', parameter.id, paramIndex, methodIndex)"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators'

export default {
  props: {
    method: Object,
    methodIndex: Number,
    courseOutcomeOptions: Array,
    validation: Object,
  },
  validations: {
    parameters: {
      $each: {
        maximum_score: {
          required,
          numeric   // allows decimals like 10.5
        }
      }
    }
  },
  methods: {
    triggerAddParameter() {
      this.$emit('addParameter', this.methodIndex);
      this.$nextTick(() => {
        this.focusEditableInput();
      });
    },
    focusEditableInput() {
      this.method.parameters.forEach((param, paramIndex) => {
        if (!param.id || param.isEditing) {
          const refName = `paramInput-${this.methodIndex}-${paramIndex}`;
          const input = this.$refs[refName];
          if (input && input[0]) {
            input[0].focus();
          }
        }
      });
    },
    startEditing(paramIndex) {
      const param = this.method.parameters[paramIndex];
      param._original = {
        serial_number: param.serial_number,
        name: param.name,
        short_code: param.short_code,
        maximum_score: param.maximum_score,
        cos: Array.isArray(param.cos) ? [...param.cos] : [],
      };
      param.isEditing = true;
    }

  }
};
</script>
